import LayoutConfigTypes from "@/core/config/LayoutConfigTypes";

const config: LayoutConfigTypes = {
  themeName: "Hacking Club",
  themeVersion: "2.2",
  demo: "demo1",
  main: {
    type: "default",
    primaryColor: "#9203DD",
    logo: {
      dark: "media/logos/hc.svg",
      light: "media/logos/hc.svg",
    },
  },
  illustrations: {
    set: "sigma-1",
  },
  loader: {
    logo: "media/logos/hc.svg",
    display: true,
    type: "spinner-logo",
  },
  scrollTop: {
    display: true,
  },
  header: {
    display: true,
    menuIcon: "font",
    width: "fluid",
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  toolbar: {
    display: false,
    width: "fluid",
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  aside: {
    display: true,
    theme: "dark",
    fixed: true,
    menuIcon: "font",
    minimized: false,
    minimize: true,
    hoverable: true,
  },
  content: {
    width: "fixed",
  },
  footer: {
    width: "fluid",
  },
};

export default config;
